module.exports = __webpack_public_path__ + "static/media/alea.275263c2.mp4";